











































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { authModule, snackModule } from '@/store';
import { Wordpress } from '@/api';
// @ts-ignore
import throttle from 'lodash/throttle';

@Component({
  components: {},
})
export default class extends Vue {
  @Prop({ required: false }) readonly acfOptions: any;

  isScrolled: boolean = false;
  scrollThottle = throttle(this.handleScroll, 200);

  mainMenu: [] | null = null;

  userMenu = [
    {
      title: 'Profile',
      to: {
        name: 'profile',
      },
      icon: 'far fa-user',
      show: () => true,
    },
    {
      title: 'My Bookings',
      to: {
        name: 'bookings',
      },
      icon: 'far fa-book',
      show: () => true,
    },
    {
      title: 'My Vehicles',
      to: {
        name: 'vehicles',
      },
      icon: 'far fa-car',
      show: () => true,
    },
    {
      title: 'Admin',
      to: {
        name: 'admin',
      },
      icon: 'far fa-cogs',
      show: () => authModule.isSalesPlus,
    },
  ];

  get filteredUserMenu() {
    return this.userMenu.filter(item => item.show());
  }

  get isLoggedIn() {
    return authModule.isLoggedIn;
  }

  menuLink(link: string) {
    if (link === '#') {
      return;
    }
    const url = new URL(link);
    if (
      window.location.hostname === url.hostname ||
      process.env.VUE_APP_WP_API_BASE === url.origin
    ) {
      this.$router.push(url.pathname);
    } else {
      window.location.href = link;
    }
  }

  sanitizePhone(phone: string) {
    const sanitizedPhone = phone.replace(/[\s)(]/g, '');
    return sanitizedPhone;
  }

  toggleMenu() {
    this.$emit('toggle-menu');
  }

  loginRegister() {
    authModule.openLoginDialog({ cb: null });
  }

  logout() {
    authModule.logout();
  }

  handleScroll(event: Event) {
    if (window.scrollY > 45) {
      this.isScrolled = true;
    } else {
      this.isScrolled = false;
    }
  }

  async mounted() {
    window.addEventListener('scroll', this.scrollThottle);

    try {
      this.mainMenu = await Wordpress.getMenuData('main');
    } catch (err) {
      // Error
    }
  }

  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollThottle);
  }
}
